import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

export const postSaveMaterialItemPositions = async (data) => {
  try {
    const res = await axiosInstance.post(API_ROUTES.SaveMaterialItemPositions, data)
    return res.data
  } catch (error) {
    console.error('Error saving material item positions:', error)
    return null
  }
}

export default postSaveMaterialItemPositions
